import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b;
import { EventDispatcher, Texture } from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { CacheEvictionPolicy } from '../utilities/cache-eviction-policy.js';
import GLTFMaterialsVariantsExtension from './gltf-instance/VariantMaterialLoaderPlugin.js';
Texture.DEFAULT_ANISOTROPY = 4;
/**
 * A helper to Promise-ify a Three.js GLTFLoader
 */
export var loadWithLoader = function loadWithLoader(url, loader) {
  var progressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onProgress = function onProgress(event) {
    var fraction = event.loaded / event.total;
    progressCallback(Math.max(0, Math.min(1, isFinite(fraction) ? fraction : 1)));
  };
  return new Promise(function (resolve, reject) {
    loader.load(url, resolve, onProgress, reject);
  });
};
/** Helper to load a script tag. */
var fetchScript = function fetchScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    document.body.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.src = src;
  });
};
var cache = new Map();
var preloaded = new Map();
var dracoDecoderLocation;
var dracoLoader = new DRACOLoader();
var ktx2TranscoderLocation;
var ktx2Loader = new KTX2Loader();
var meshoptDecoderLocation;
var meshoptDecoder;
export var $loader = Symbol('loader');
export var $evictionPolicy = Symbol('evictionPolicy');
var $GLTFInstance = Symbol('GLTFInstance');
export var CachingGLTFLoader = /*#__PURE__*/function (_EventDispatcher, _ref) {
  _inherits(CachingGLTFLoader, _EventDispatcher);
  var _super = _createSuper(CachingGLTFLoader);
  function CachingGLTFLoader(GLTFInstance) {
    var _this;
    _classCallCheck(this, CachingGLTFLoader);
    _this = _super.call(this);
    _this[_b] = new GLTFLoader().register(function (parser) {
      return new GLTFMaterialsVariantsExtension(parser);
    });
    _this[$GLTFInstance] = GLTFInstance;
    _this[$loader].setDRACOLoader(dracoLoader);
    _this[$loader].setKTX2Loader(ktx2Loader);
    return _this;
  }
  _createClass(CachingGLTFLoader, [{
    key: _ref,
    get: function get() {
      return this.constructor[$evictionPolicy];
    }
    /**
     * Preloads a glTF, populating the cache. Returns a promise that resolves
     * when the cache is populated.
     */
  }, {
    key: "preload",
    value: function () {
      var _preload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, element) {
        var progressCallback,
          rawGLTFLoads,
          GLTFInstance,
          gltfInstanceLoads,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              progressCallback = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
              this[$loader].setWithCredentials(CachingGLTFLoader.withCredentials);
              this.dispatchEvent({
                type: 'preload',
                element: element,
                src: url
              });
              if (cache.has(url)) {
                _context.next = 14;
                break;
              }
              if (!(meshoptDecoder != null)) {
                _context.next = 10;
                break;
              }
              _context.t0 = this[$loader];
              _context.next = 8;
              return meshoptDecoder;
            case 8:
              _context.t1 = _context.sent;
              _context.t0.setMeshoptDecoder.call(_context.t0, _context.t1);
            case 10:
              rawGLTFLoads = loadWithLoader(url, this[$loader], function (progress) {
                progressCallback(progress * 0.8);
              });
              GLTFInstance = this[$GLTFInstance];
              gltfInstanceLoads = rawGLTFLoads.then(function (rawGLTF) {
                return GLTFInstance.prepare(rawGLTF);
              }).then(function (preparedGLTF) {
                progressCallback(0.9);
                return new GLTFInstance(preparedGLTF);
              }).catch(function (reason) {
                console.error(reason);
                return new GLTFInstance();
              });
              cache.set(url, gltfInstanceLoads);
            case 14:
              _context.next = 16;
              return cache.get(url);
            case 16:
              preloaded.set(url, true);
              if (progressCallback) {
                progressCallback(1.0);
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function preload(_x, _x2) {
        return _preload.apply(this, arguments);
      }
      return preload;
    }()
    /**
     * Loads a glTF from the specified url and resolves a unique clone of the
     * glTF. If the glTF has already been loaded, makes a clone of the cached
     * copy.
     */
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, element) {
        var _this2 = this;
        var progressCallback,
          gltf,
          clone,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              progressCallback = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : function () {};
              _context2.next = 3;
              return this.preload(url, element, progressCallback);
            case 3:
              _context2.next = 5;
              return cache.get(url);
            case 5:
              gltf = _context2.sent;
              _context2.next = 8;
              return gltf.clone();
            case 8:
              clone = _context2.sent;
              this[$evictionPolicy].retain(url);
              // Patch dispose so that we can properly account for instance use
              // in the caching layer:
              clone.dispose = function () {
                _this2[$evictionPolicy].release(url);
              };
              return _context2.abrupt("return", clone);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x3, _x4) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }], [{
    key: "setDRACODecoderLocation",
    value: function setDRACODecoderLocation(url) {
      dracoDecoderLocation = url;
      dracoLoader.setDecoderPath(url);
    }
  }, {
    key: "getDRACODecoderLocation",
    value: function getDRACODecoderLocation() {
      return dracoDecoderLocation;
    }
  }, {
    key: "setKTX2TranscoderLocation",
    value: function setKTX2TranscoderLocation(url) {
      ktx2TranscoderLocation = url;
      ktx2Loader.setTranscoderPath(url);
    }
  }, {
    key: "getKTX2TranscoderLocation",
    value: function getKTX2TranscoderLocation() {
      return ktx2TranscoderLocation;
    }
  }, {
    key: "setMeshoptDecoderLocation",
    value: function setMeshoptDecoderLocation(url) {
      if (meshoptDecoderLocation !== url) {
        meshoptDecoderLocation = url;
        meshoptDecoder = fetchScript(url).then(function () {
          return MeshoptDecoder.ready;
        }).then(function () {
          return MeshoptDecoder;
        });
      }
    }
  }, {
    key: "getMeshoptDecoderLocation",
    value: function getMeshoptDecoderLocation() {
      return meshoptDecoderLocation;
    }
  }, {
    key: "initializeKTX2Loader",
    value: function initializeKTX2Loader(renderer) {
      ktx2Loader.detectSupport(renderer);
    }
  }, {
    key: "cache",
    get: function get() {
      return cache;
    }
    /** @nocollapse */
  }, {
    key: "clearCache",
    value: function clearCache() {
      var _this3 = this;
      cache.forEach(function (_value, url) {
        _this3.delete(url);
      });
      this[$evictionPolicy].reset();
    }
  }, {
    key: "has",
    value: function has(url) {
      return cache.has(url);
    }
    /** @nocollapse */
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
        var gltfLoads, gltf;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.has(url)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              gltfLoads = cache.get(url);
              preloaded.delete(url);
              cache.delete(url);
              _context3.next = 7;
              return gltfLoads;
            case 7:
              gltf = _context3.sent;
              // Dispose of the cached glTF's materials and geometries:
              gltf.dispose();
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * Returns true if the model that corresponds to the specified url is
     * available in our local cache.
     */
  }, {
    key: "hasFinishedLoading",
    value: function hasFinishedLoading(url) {
      return !!preloaded.get(url);
    }
  }]);
  return CachingGLTFLoader;
}(EventDispatcher, (_a = $evictionPolicy, _b = $loader, $evictionPolicy));
CachingGLTFLoader[_a] = new CacheEvictionPolicy(CachingGLTFLoader);